import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaInstagram } from "react-icons/fa6";
import { FaTiktok } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from 'react-router-dom';
export default function Footer() {
  const location = useLocation();

  // إخفاء الـ Footer في صفحة Dashboard
  if (location.pathname.includes('/dashboard')) {
    return null;
  }

  return (
    <footer className='d-flex align-items-center justify-content-center'>
      <div className='maxw d-flex align-items-center justify-content-center gap-2'>
        <div className='d-flex gap-2'>
          <a href="https://www.instagram.com/gedarstore" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.tiktok.com/@gedarstore" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
          <a href="https://wa.me/201551932386" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
        </div>
      </div>
      <p className='text-white mb-0 mt-2 poweredby'>Powered By <a href="https://www.instagram.com/fusion_hq_?igsh=MTV5Z3hweG8waW9xbA=="><span className='fw-bold underline'>Fusion_HQ</span></a></p>
    </footer>
  );
}
